'use strict';

var lib = require('./lib-75591456.js');
var icon = require('./icon-e3ab87ed.js');

var DIAGONAL_ARROW_UP_LEFT = 'M4 19.0748L4 4L19.0748 4L19.0296 6.70804L8.53597 6.68547L20 18.1495L18.1495 20L6.68547 8.53597L6.66291 19.0748H4Z';
var IconDiagonalArrowUpLeft = lib.variant('IconDiagonalArrowUpLeft', icon.Icon, {
    path: DIAGONAL_ARROW_UP_LEFT,
});

exports.IconDiagonalArrowUpLeft = IconDiagonalArrowUpLeft;
//# sourceMappingURL=index-d2cbbcba.js.map
